export default "__VITE_ASSET__eZQn2pdO__"